import { createTheme } from "@mui/material/styles";
export const appTheme = createTheme({
  typography: {
    fontFamily: `IBM+Plex+Mono`,
  },
  palette: {
    primary: {
      main: "#393939",
      // light: '#757ce8',
      // dark: '#002884',
      // contrastText: '#fff',
    },
    secondary: {
      main: "#FF5D0A",
      // light: '#757ce8',
      // dark: '#002884',
      // contrastText: '#fff',
    },
    third: {
      main: "#FFDA15",
    //   light: '#56D26A'
    },
    fourth: {
        main: "#56D26A",
      //   light: '#56D26A'
      },
      Fifth: {
        main: "#FF0000",
      //   light: '#56D26A'
      },
      transparent:{
        main:"#FFFFFF"
      },
      greylighter:{
        main:"#EAEAEA"
      }
  },
});